import { Form, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import AcContext from "../../../../../context/activityConsultingContext";

function ExpertField({ expertDataQuery, statics }) {
  const [activityFieleds, setActevityFields] = useState();
  const [consultingFields, setConsultingFields] = useState();

const [form] = Form.useForm()

const {consultingFieldsIdsAction,activityFieldsIdsAction} = useContext(AcContext)  

  useEffect(() => {
    if (expertDataQuery) {
      if (
        expertDataQuery?.modifiedExpert &&
        expertDataQuery?.modifiedExpert?.activityFields !== "NOT_MODIFIED"
      ) {
        setActevityFields(
          expertDataQuery?.modifiedExpert?.activityFields.map((item) => {
            return { label: item?.name, value: item?.id };
          })
        );
      } else {
        setActevityFields(
          expertDataQuery?.expert?.activityFields.map((item) => {
            return { label: item?.name, value: item?.id };
          })
        );
      }
    }
  }, [expertDataQuery]);

  useEffect(() => {
    if (expertDataQuery) {
      if (
        expertDataQuery?.modifiedExpert &&
        expertDataQuery?.modifiedExpert?.consultingFields !== "NOT_MODIFIED"
      ) {
        setConsultingFields(
          expertDataQuery?.modifiedExpert?.consultingFields.map((item) => {
            return { label: item?.name, value: item?.id };
          })
        );
      } else {
        setConsultingFields(
          expertDataQuery?.expert?.consultingFields?.map((item) => {
            return { label: item?.name, value: item?.id };
          })
        );
      }
    }
  }, [expertDataQuery]);

  const activityFieledsOption = statics?.EXECUTIVE_SKILLS?.filter((itm) => itm?.categoryEN === 'EXECUTIVE_SKILLS_CONSULTING')
  const consultingFieldsOption = statics?.EXECUTIVE_SKILLS?.filter((itm) => itm?.categoryEN === 'EXECUTIVE_SKILLS_ACTIVITY')
 

  const reformatData = (data) =>{
    const reformat = data?.map((item)=>({label:item?.name, value:item?.id}))
    return reformat
  }

  useEffect(()=>{
    if(activityFieleds, consultingFields) {
      form.setFieldsValue({
          activityFieledId:activityFieleds?.map((itm)=>({label:itm?.label,value:itm?.value})),
          consultingFieldId:consultingFields?.map((itm)=>({label:itm?.label,value:itm?.value}))
      })
      activityFieldsIdsAction(activityFieleds?.map((item)=>item?.value))
      consultingFieldsIdsAction(consultingFields?.map((item)=>item?.value))
    }
  },[activityFieleds, consultingFields])

  
  return (
    <Form layout="vertical" form={form}>
      <section className="flex flex-row max-lg:flex-col justify-evenly gap-3">
        <Form.Item
        name='activityFieledId'
        label="حوزه فعالیت" className="w-1/2 max-lg:w-full"
        
        >
       
            <Select
              className="font-body "
              mode="multiple"
              clearIcon
              onChange={(e)=>{activityFieldsIdsAction(e)}}
              showSearch={false}
              options={reformatData(activityFieledsOption)}
            />
      
        </Form.Item>
        <Form.Item
        name='consultingFieldId'
        initialValue={13}
        label="زمینه مشاوره" className="w-1/2 max-lg:w-full">
          
            <Select
              className="font-body "
              mode="multiple"
              onChange={(e)=>{consultingFieldsIdsAction(e)}}
              clearIcon
                options={reformatData(consultingFieldsOption)}
              showSearch={false}
            />
       
        </Form.Item>
      </section>
    </Form>
  );
}

export default ExpertField;
